export const AlgoliaAPIKey = 'MGVBNW1DT0';

export const AlgoliaAdminAPIKey = '6ea8ae1cd3ce1bad5e73ee0e1462007d';

export const mapBoxKey = 'pk.eyJ1IjoibWFwdHJhaW5yZXgiLCJhIjoiY20zaDYwb3U5MDZibzJsc2E3Z3NrbG1pbiJ9.InsmhQWm8rZ5bvsIrE-U6w';